import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class CabinCrew extends Component {
  render() {
    return (
      <Fragment>
        <div className="page-title-banner _about">
          <div className="title">
            <h1>Canada</h1>
          </div>
        </div>

        <div className="page-content container-fluid pt-5 bm-5">
          <div className="inside-page-section _about container pt-5 pb-5 mb-5">
            <div className="row">
              <div className="box  left col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="title mb-5">
                  <h4>Canada Job Opening Application Procedures (Revised)</h4>
                  <b>
                    Due to the pandemic, IPAMS is not accepting walk-in
                    applications at the moment. All applications must be done
                    online via:{" "}
                  </b>
                  <ul className="mt-2 mb-2">
                    <li>
                      <b>
                        •{" "}
                        <a
                          className="text-primary"
                          href="https://ipams.com/jobseeker"
                          target="_blank"
                        >
                          https://ipams.com/jobseeker
                        </a>
                      </b>
                    </li>
                    <li>
                      <b>
                        • IPAMS Mobile App – download for free through Apple
                        Store or Google Play
                      </b>
                    </li>
                  </ul>
                  <b>
                    Only applicants with PEOS Certification will be interviewed
                    once initially suitable for the post.
                  </b>
                </div>
                <div className="text col-12 m-0 mb-1">
                  <p className="text-bold mb-0">Step 1 – ONLINE REGISTRATION</p>
                  <div className="ml-3">
                    <p>
                      Go to{" "}
                      <a
                        className="text-primary"
                        href="http://www.ipams.com/jobseeker"
                        target="_blank"
                      >
                        JOB SEEKERS
                      </a>
                       search for your desired position in the “Search
                      Jobs/Employers” field. If we have a job opening, it will
                      appear in your search. Click and read through the details.
                      Scroll down and click the “REGISTER TO APPLY” button.
                    </p>
                    <p>
                      If there is a problem in the registration process, go to
                      the FAQ section “Encountering Problems Applying” by
                      clicking here -{" "}
                      <a
                        className="text-primary"
                        href="https://ipams.com/faq"
                        target="_blank"
                      >
                        https://ipams.com/faq{" "}
                      </a>
                    </p>
                    <p>
                      Recruiters screen applications daily. If you qualify for
                      the post, an IPAMS recruitment officer will invite you for
                      initial screening via call or video call.{" "}
                    </p>
                  </div>
                  <p className="text-bold mt-4 mb-1">
                    Step 2 – INITIAL SCREENING
                  </p>
                  <div className="ml-3">
                    <p>
                      All interested applicants will be contacted for a
                      preliminary interview via call or video interview via
                      Skype.{" "}
                    </p>

                    <p>
                      Our recruiters will ask your permission for the video
                      interview to be recorded for reference purposes. Said
                      video interview will only be shared with the potential
                      employers with your permission per our “Data Privacy Act”
                      policy.{" "}
                    </p>
                    <p>
                      IPAMS is open Mondays to Thursday, 8:00 am - 5:00 pm
                      (until further notice){" "}
                    </p>

                    <p>
                      <b>Required Documents:</b>
                    </p>
                    <p>Prepare the following documents listed below:</p>
                    <p>
                      <b>A. Filled out Application Form</b> from the Website.
                      Once filled out, save it as a PDF. Make sure that the form
                      is signed.{" "}
                    </p>
                    <p className="ml-3">
                      Select the “General Application Form” during registration,
                      or when updating your registration from our website.
                    </p>
                    <p>
                      <b>B. Detailed and updated resume/CV</b> Make sure that
                      you incorporate dates of your employment and employment
                      gaps. Put a job description in each work experience as
                      well as your achievements. Do not limit your
                      resume/updated CV to just two pages. The more detailed,
                      the better. How to create that winning CV?{" "}
                      <a
                        href="http://bit.ly/2GP3H7p"
                        target="_blank"
                        className="text-primary"
                      >
                        Click this link for details
                      </a>
                    </p>
                    <p>
                      <b>C. Updated photo on a resume. </b>Your profile photo
                      must be taken within 6 months during your application.
                    </p>
                    <p>
                      <b>D.</b> Printed mandatory 
                      <a
                        href="https://www.ipams.com/advisories"
                        target="_blank"
                        className="text-primary"
                      >
                        {" "}
                        PEOS certificate and e-Registration form
                      </a>
                    </p>
                    <p>
                      <b>E. Passport </b>(valid for at least 3 years from the
                      time of application). How will you know if your passport
                      is still valid for your dream job?{" "}
                      <a
                        href="http://bit.ly/35AY9rn"
                        target="_blank"
                        className="text-primary"
                      >
                        Click this link
                      </a>
                    </p>
                    <p>
                      <b>F. SSS employment history.</b>{" "}
                    </p>

                    <p>
                      <b>G. Employment certificates </b>(or contract/company
                      ID/latest payslips/OFW Information Sheet as proof of
                      employment if COE is not available)
                    </p>
                    <p className="ml-3">
                      For ex-Abroad who will request for OFW Information Sheet
                      at the POEA, please click this link -{" "}
                      <a
                        href="http://ofwrecords.poea.gov.ph/ofwAppointment.php"
                        target="_blank"
                        className="text-primary"
                      >
                        Click Here
                      </a>
                    </p>

                    <p>
                      <b>
                        H. High school/college/vocational diploma/TESDA
                        certificate.
                      </b>
                    </p>

                    <p>
                      <b>I. Form 137/Transcript of records.</b>
                    </p>

                    <p>
                      <b>J. Valid NBI clearance (Multi-Purpose).</b>
                    </p>
                    <p>
                      <b>
                        How to get your NBI Clearance,{" "}
                        <a
                          href="https://nbiclearance-online.com/"
                          target="_blank"
                          className="text-primary"
                        >
                          Click here.
                        </a>
                      </b>
                    </p>
                    <p>
                      <b>K. Foreign police clearance </b> (if you stayed/worked
                      in a foreign country for 6 months and up in the last 5
                      years)
                    </p>
                    <p>
                      <b>
                        To know if the country you previously worked in requires
                        a Foreign Police Clearance.
                        <a
                          href="https://www.canada.ca/en/immigration-refugees-citizenship/services/application/medical-police/police-certificates/how.html"
                          target="_blank"
                          className="text-primary"
                        >
                          {" "}
                          Click here.
                        </a>
                      </b>{" "}
                    </p>

                    <p>
                      <b>L. PSA birth certificate.</b>
                    </p>
                    <p>
                      <b>M. PSA marriage certificate </b>(if applicable)
                    </p>

                    <p>
                      <b>N. Training certificates/other supporting documents</b>
                    </p>
                    <p>
                      IMPORTANT NOTE: Supporting documents must be authentic.
                      Giving false information or fake document is a
                      misrepresentation which is A SERIOUS OFFENSE against
                      Canada's immigration rule.
                    </p>
                  </div>

                  <p>
                    <b>
                      Step 3 – ENDORSEMENT OF APPLICATION TO EMPLOYER/CLIENT
                    </b>
                  </p>
                  <div className="ml-3">
                    <p>
                      Upon verification of documents by IPAMS, your profile will
                      be forwarded to the employer for further review and
                      evaluation.
                    </p>
                  </div>
                  <div className="ml-3">
                    <p>
                      You will then be shortlisted if found suitable for the
                      post.
                    </p>
                  </div>
                  <p>
                    <b>Step 4 – FINAL INTERVIEW WITH THE EMPLOYER</b>
                  </p>
                  <div className="ml-3">
                    <p>
                      Only shortlisted candidates will be notified by IPAMS via
                      e-mail, SMS, or telephone call to report for the final
                      interview.
                    </p>
                  </div>
                  <div className="ml-3">
                    <p>
                      The final interview will be via a video call (depending on
                      the employer’s preference, possible video call tools to
                      use via your smartphone or laptop/desktop would be Skype,
                      Zoom, Microsoft Team Meetings, Google Meet, BlueJeans
                      Apps, or other means available). A link or invitation will
                      be sent to your email.
                    </p>
                  </div>
                  <div className="ml-3">
                    <p>
                      The final interview schedule is usually posted on the
                      IPAMS website (News & Events) and our Official Facebook
                      page.
                    </p>
                  </div>
                  <p>
                    <b>Special Note:</b>
                  </p>
                  <p>
                    • If you have not received any notification from IPAMS one
                    week before the final interview dates, it means that you
                    were not shortlisted.
                  </p>

                  <p>
                    <b>Step 5 – FINAL INTERVIEW SELECTION/JOB OFFER</b>
                  </p>
                  <p>
                    Selected candidates from the final interview will be
                    notified by IPAMS via e-mail, SMS, or telephone call to
                    attend the virtual offer orientation scheduled by our
                    operations/mobilization team.{" "}
                  </p>
                  <p>
                    Those who are not selected will also receive notification
                    within one (1) week after the final interview from our
                    recruiters.{" "}
                  </p>
                  <p>
                    Special Note: For those who were not selected, your profile
                    will be in our pool within six (6) months from application.
                    You will be contacted or you may apply again after 6 months
                    should there be any suitable job openings for you in the
                    future.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="m-5 p-5"></div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapStateToProps)(CabinCrew));
